module.exports = __webpack_public_path__ + "img/select_style_diy.4acdfef5.png";